import React, { useEffect } from 'react';

import SidebarHeader from '../components/SidebarHeader';
import { ALERT_SIDEBAR_TABS } from './modules/tabConfig';
import Connector, { PropsFromRedux } from './Connector';
import { AlertSidebarWrapper } from '../styled';
import { useDocumentVisibility } from 'src/utils/hooks/useDocumentVisibility';

type Props = PropsFromRedux;

const AlertSidebar = ({
  activeTab,
  changeSidebarTab,
  onMount,
  onUnmount,
  fetchHistoricalAlerts,
}: Props) => {
  const isDocumentVisible = useDocumentVisibility();

  useEffect(() => {
    if (!isDocumentVisible) {
      return;
    }
    onMount();
    fetchHistoricalAlerts([]);
    return () => {
      onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDocumentVisible]);

  return (
    <AlertSidebarWrapper data-cy="alerts-sidebar">
      <SidebarHeader
        tabKey={activeTab}
        tabConfig={ALERT_SIDEBAR_TABS}
        onChangeTab={id => {
          changeSidebarTab(id as typeof activeTab);
        }}
      />
      {ALERT_SIDEBAR_TABS[activeTab].render()}
    </AlertSidebarWrapper>
  );
};

export default Connector(AlertSidebar);
